// utils/encryption.ts

export async function encryptAES(text: string, password: string): Promise<string> {
	const enc = new TextEncoder();

	// Generate salt and IV
	const salt = crypto.getRandomValues(new Uint8Array(16));
	const iv = crypto.getRandomValues(new Uint8Array(16));

	// Derive key using PBKDF2
	const keyMaterial = await crypto.subtle.importKey("raw", enc.encode(password), { name: "PBKDF2" }, false, [
		"deriveKey"
	]);

	const key = await crypto.subtle.deriveKey(
		{
			name: "PBKDF2",
			salt,
			iterations: 100000,
			hash: "SHA-256"
		},
		keyMaterial,
		{ name: "AES-CBC", length: 256 },
		false,
		["encrypt"]
	);

	const encrypted = await crypto.subtle.encrypt({ name: "AES-CBC", iv }, key, enc.encode(text));

	// Return base64 string with salt + iv + encrypted data
	const encryptedArray = Array.prototype.slice.call(new Uint8Array(encrypted));
	const fullBuffer = new Uint8Array([
		...Array.prototype.slice.call(salt),
		...Array.prototype.slice.call(iv),
		...encryptedArray
	]);
	return btoa(String.fromCharCode(...Array.from(fullBuffer)));
}
